/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function CameraByIdLoadedReducer
 *  *
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeCameraByIdLoadedAction } action: action
 *     de l'application
 * @return { Reducer }
 */
export const CameraByIdLoadedReducer: Reducer<CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeCameraByIdLoadedAction) => {
      switch (action.type) {
        case actions.CameraByIdLoadedActionTypes.CAMERABYIDLOADED_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.CameraByIdLoadedActionTypes.CAMERABYIDLOADED_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.CameraByIdLoadedActionTypes.CAMERABYIDLOADED_SUCCESS:
          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/tunnelwatch/camerabyid/index.ts